import React, {Component} from 'react';
import {bindActionCreators} from 'redux';
import {withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import {Button, message, Divider, Tooltip, Table, Switch, Modal} from "antd";
import moment from 'moment'
import {fetchSyncInfoWasabi} from "../../../actions/sync-info-wasabi";
import {refresh_profile} from "../../../actions/auth";
import CloudFlyerAPI from '../../../api/CloudFlyerAPI'
import infoIcon from '../../../assets/svg/info_icon.svg';

import './SyncList.scss';

class SyncList extends Component {

    constructor(props) {
        super();

        this.state = {
            syncInfoList: [],
        }
    }

    componentDidMount() {
        this.props.fetchSyncInfoWasabi();
        this.props.refresh_profile(true);
    }

    componentWillReceiveProps({syncInfoWasabi, user}) {
        if (syncInfoWasabi.error) {
            message.error(syncInfoWasabi.error);
        } else {
            this.setState({
                syncInfoList: syncInfoWasabi.items,
                user
            });
        }
    }

    handleActivateClick = (syncId, active) => {

        let activateMessage = ""
        if (active) {
            activateMessage = "deactivate"
        } else {
            activateMessage = "activate"
        }

        CloudFlyerAPI
            .new_user_account
            .activateSync({
                id: syncId,
                active: !active
            })
            .then(response => {
                message.success(`Sync Information ${activateMessage} successfully!`)
                this.props.fetchSyncInfoWasabi();
            })
            .catch(err => {
                message.error("Something went wrong.")
            })
    }

    handleDeleteClick = (syncId) => {

        CloudFlyerAPI
            .new_user_account
            .deleteSync(syncId)
            .then(response => {
                message.success("Sync Information deleted successfully!")
                this.props.fetchSyncInfoWasabi();
            })
            .catch(err => {
                message.error("Something went wrong.")
            })


    }

    faultedTooltip(status, error) {
        if (status === 'Faulted') {
            if (error === undefined) {
                error = "Error";
            }
            return (<div className="faulted-tooltip">Faulted <Tooltip placement="right" title={error}><img src={infoIcon} alt="info"/></Tooltip></div>);
        }
        return status;
    }


    // handleTriggerClick  = (syncId) => {
    //     CloudFlyerAPI
    //     .user_account
    //     .triggerSyncWasabi(syncId)
    //     .then(response => {
    //         message.success("Sync started successfully!")
    //         this.props.fetchSyncInfoWasabi();
    //     })
    //     .catch(err => {
    //         message.error("Something went wrong.")
    //     })
    // }

    render() {

        const columns = [
            {
                title: 'Source',
                dataIndex: 'source',
                key: 'source',
                ellipsis: {
                    showTitle: false,
                },
                render: source => (
                    <Tooltip placement="topLeft" title={source}>
                        {source}
                    </Tooltip>
                ),
                width: 180,
            },
            {
                title: 'Destination',
                dataIndex: 'destination',
                key: 'destination',
                ellipsis: {
                    showTitle: false,
                },
                render: destination => (
                    <Tooltip placement="topLeft" title={destination}>
                        {destination}
                    </Tooltip>
                ),
                width: 180,
            },
            {
                title: 'Created',
                dataIndex: 'created',
                key: 'created',
                ellipsis: {
                    showTitle: false,
                },
                width: 150,
            },
            {
                title: 'Last Executed',
                dataIndex: 'lastExecuted',
                key: 'lastExecuted',
                ellipsis: {
                    showTitle: false,
                },
                width: 150,
            },
            {
                title: () => {
                    return (<div><Tooltip
                        placement="right"
                        title="Object will be deleted in destination, if it is deleted from source bucket."
                        getPopupContainer={trigger => trigger.parentElement}
                    >
                        <img src={infoIcon} alt="info"/>
                    </Tooltip> Sync Delete</div>)
                },
                dataIndex: 'syncDelete',
                key: 'syncDelete',
                width: 120,
            },
            {
                title: 'Status',
                dataIndex: 'status',
                key: 'status',
                width: 130,
            },
            {
                title: 'Active',
                dataIndex: 'activeData',
                key: 'activeData',
                ellipsis: {
                    showTitle: false,
                },
                render: activeData => (
                    <Switch
                        size="small"
                        checked={activeData.active}
                        onChange={e =>
                            showActivateConfirm(e, this.handleActivateClick, activeData.id, (activeData.source + " to " + activeData.destination), activeData.active)
                        }
                    />
                ),
                width: 80,
            },
            {
                title: 'Delete',
                dataIndex: 'deleteData',
                key: 'deleteData',
                ellipsis: {
                    showTitle: false,
                },
                render: deleteData => (
                    <Button
                        className="replication-delete-btn"
                        icon="delete"
                        onClick={e =>
                            showDeleteConfirm(e, this.handleDeleteClick, deleteData.id, (deleteData.source + " to " + deleteData.destination))
                        }
                    />
                ),
                width: 80,
            }


        ];

        let statusMap = new Map()
        statusMap.set(0, "Processing")
        statusMap.set(1, "Transferring")
        statusMap.set(2, "Completed")
        statusMap.set(4, "Cancelled")
        statusMap.set(8, "Faulted")
        statusMap.set(16, "NoChange")
        let data = this.state.syncInfoList?.map((t, index) => {
            return {
                id: t.info.id,
                source: t.info.sourceCloudAccount.name + ' > ' + t.info.sourceBucket,
                destination: t.info.destinationCloudAccount.name + ' > ' + t.info.destinationBucket,
                created: moment.parseZone(t.info.createDate).local().format('MM/DD/YYYY - HH:mm'),
                lastExecuted: t.lastCycle?.date ? moment.parseZone(t.lastCycle?.date).local().format('MM/DD/YYYY - HH:mm') : '',
                syncDelete: t.info.allowDelete ? 'Yes' : 'No',
                status: this.faultedTooltip(statusMap.get(t.lastCycle?.status), t.lastError),
                activeData: {
                    active: t.info.active,
                    source: t.info.sourceCloudAccount.name + ' > ' + t.info.sourceBucket,
                    destination: t.info.destinationCloudAccount.name + ' > ' + t.info.destinationBucket,
                    id: t.info.id
                },
                deleteData: {
                    source: t.info.sourceCloudAccount.name + ' > ' + t.info.sourceBucket,
                    destination: t.info.destinationCloudAccount.name + ' > ' + t.info.destinationBucket,
                    id: t.info.id
                }

            }
        })


        return (
            <div className="syncWrapper">
                <div>
                    <Table columns={columns} dataSource={data} pagination={false}/>
                </div>

            </div>
        )
    }
}


function mapStateToProps({syncInfoWasabi, auth: {user} = {}}) {
    return {syncInfoWasabi, user};
}

function mapDispatchToProps(dispatch) {
    return {
        fetchSyncInfoWasabi: bindActionCreators(fetchSyncInfoWasabi, dispatch),
        refresh_profile
    };
}

const showActivateConfirm = (e, handleActivateClick, syncId, destination, active) => {
    //e.stopPropagation()
    let activateMessage = ""
    if (active) {
        activateMessage = "deactivate"
    } else {
        activateMessage = "activate"
    }

    Modal.confirm({
        title: `Are you sure you want to ${activateMessage} the ${destination} Sync?`,
        content:
            "",
        onOk() {
            handleActivateClick(syncId, active)
        }
    })
}

const showDeleteConfirm = (
    e,
    handleDeleteClick,
    syncId,
    destination
) => {
    e.stopPropagation()
    Modal.confirm({
        title: `Do you want to remove the ${destination} Sync Information?`,
        content:
            "This will only remove your Sync Information from CloudFlyer.",
        onOk() {
            handleDeleteClick(syncId)
        }
    })
}


export default withRouter(
    connect(
        mapStateToProps,
        mapDispatchToProps
    )(SyncList)
);
